import classNames from 'classnames';
import React, {ChangeEvent, FC, SetStateAction} from 'react';
import uploadFileDisabledIcon from '~/shared/legacy_res/img/svg/upload-file-disabled.svg';
import uploadFileIcon from '~/shared/legacy_res/img/svg/upload-file.svg';
import {fileValidation} from '../../model/fileValidation';
import {DialogProps} from '../UploadStatusDialog';
import RsnUploadButton from './RsnUploadButton';
import styles from './UploadButton.module.scss';

const filesExtText = 'PNG, JPG, GIF, TIFF, PDF, HEIC or BMP';
const accept = '.jpg, .jpeg, .jpe, .png, .gif, .heic, .heif, .pdf, .bmp, .tiff, .tif;capture=camera';

export interface UploadButtonProps {
    fileList: File[];
    setDialog: (error: undefined | DialogProps) => void;
    setFileList: (fileList: SetStateAction<File[]>) => void;
    disabled: boolean;
    maxFilesAmount: number;
}

/**
 * @deprecated After releasing new KYC flow, use {@link FileInput}
 */
const UploadButton: FC<UploadButtonProps> = ({fileList, setDialog, setFileList, disabled, maxFilesAmount}) => {
    const uploadFile = disabled ? uploadFileDisabledIcon : uploadFileIcon;

    const onUpload = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const {files} = e.currentTarget;
        const inputFiles = Array.from(files || []);
        setDialog(undefined);
        if (inputFiles.length) {
            const {files, errors} = fileValidation(fileList, inputFiles, maxFilesAmount);
            setFileList(Array.from(files));

            if (errors.tooManyFiles) {
                setDialog({
                    title: 'You tried to upload too many files',
                    message:
                        'We uploaded as many files as we could. If the required files have not been uploaded, replace any that are not needed.',
                    type: 'error',
                });
            }

            if (errors.listOversized) {
                setDialog({
                    title: 'Total file size has exceeded the limit',
                    message: 'The maximum combined size of all uploaded files should not exceed 60 MB.',
                    type: 'error',
                });
            }

            if (errors.wrongSizeFilenames.length) {
                setDialog({
                    title: 'Some of the uploaded files exceed the size limit',
                    message:
                        'We uploaded the files that we could. If the size of the required files exceeds 25 MB,' +
                        ' reduce their size or choose alternative files.',
                    fileNames: errors.wrongSizeFilenames,
                    type: 'error',
                });
            }
        }
    };

    return (
        <div className={classNames(styles.uploadZone, disabled && styles.disabled)}>
            <RsnUploadButton accept={accept} onChangeHandler={onUpload} disabled={disabled} multiple>
                <div className={styles.header}>
                    <img src={uploadFile} alt='upload' />
                    Upload documents
                </div>
                <div className={styles.filesInfo}>
                    {filesExtText} <br />
                    Maximum size for one document: 25 MB
                </div>
            </RsnUploadButton>
        </div>
    );
};

export default UploadButton;
